import {
  Badge,
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@cargomatic/ui';
import i18next from 'i18next';
import React, { useMemo } from 'react';
import { sluggify } from 'utils/localization/utils';

const VISIBLE_ITEMS_COUNT = 2;
export function HoverBadges({ value, doSluggify = true }) {
  const count = useMemo(
    () => (value?.length ?? 0) - VISIBLE_ITEMS_COUNT,
    [value],
  );
  const showCount = useMemo(() => {
    return count > 0;
  }, [count]);

  const visibleItems = useMemo(() => {
    if (count > 0) {
      return (value || []).slice(0, VISIBLE_ITEMS_COUNT);
    }
    return value || [];
  }, [count, value]);

  const hoverItems = useMemo(() => {
    if (count > 0) {
      return (value || []).slice(VISIBLE_ITEMS_COUNT);
    }
    return null;
  }, [count, value]);
  return (
    <div className="flex gap-2 py-2">
      <div className="flex flex-wrap gap-2">
        {visibleItems.map((item, i) => {
          return (
            <Badge key={i}>
              {doSluggify ? i18next.t(sluggify(item)) : item}
            </Badge>
          );
        })}
      </div>
      {showCount && (
        <div className="flex-1">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="icon"
                  size="icon"
                  className="underline text-blue-500 hover:text-blue-700"
                >
                  +{count}
                </Button>
              </TooltipTrigger>
              <TooltipContent className="max-w-sm">
                <div className="flex flex-wrap gap-2">
                  {(hoverItems ?? []).map((item, i) => {
                    return (
                      <Badge key={i}>
                        {doSluggify ? i18next.t(sluggify(item)) : item}
                      </Badge>
                    );
                  })}
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}
    </div>
  );
}
